import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=3ec9f6bc&"
import script from "./Procedure.vue?vue&type=script&lang=js&"
export * from "./Procedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports